module.exports = __webpack_public_path__ + "img/1.df6d63d4.png";